module.exports = __webpack_public_path__ + "img/shape_rectangle--black.c4ac4ba.webp";